export enum SettingsOption {
    // JUDET = 'Județe',
    REQUEST_TYPES = "Tipuri Cereri",
    CERERE_PRIORITY = "Prioritate Cerere",
    STATUS = "Status Cerere",
    DOCUMENT_CATEGORY = "Categorii Documente",
    DOCUMENT_TYPE = "Tipuri Documente",
    DOCUMENT_TEMPLATE = "Template Documente",
    REGISTRE = "Registre",
    // SEMNATARI = 'Semnatari',
    OPERATORI = "Operatori",
    ZILE_LIBERE = "Zile libere",
    BORDEROU = "Borderou",
    EMAILS_BLACKLIST = 'Blacklist',
}

export enum AdminSettings {
    CONFIGURARI = 'Configurări',
    TYPE_IMAGE_DIMENSIONS = 'Dimensiuni Tip Imagini',
    CRONS = 'Cron-uri',
}
